(function ($) {
	$(document).ready(function () {

		if ($('.events-list').length > 0) {
			const wrapper = $('.events-list');
			const target = $('.events-list__inner .result-list');
			const eventDate = wrapper.data('event-date');
			const type = wrapper.data('type');
			let _lang = $('.currentLang').val();
      let _path = drupalSettings.path.baseUrl;

			let data = {
				eventDate: eventDate,
				type: type,
				totalCount: 0,
				itemsLoaded: 0,
				offset: 0,
        currentLang: _lang,
        endpoint: (_lang != 'en') ? _path + _lang + '/ajax/get-events' : _path + 'ajax/get-events'
			};

      let $grid = target.masonry({
        itemSelector: '.card--event-card',
      });

      console.log(data);

      $grid.imagesLoaded().progress(function () {
        $grid.masonry('layout');
      });

			$('.events-list-filter').each(function () {
				data[$(this).data('filter')] = '';
			});

			$.when(submitEventsFilters(data, target, 'replace',  $grid)).done(function (results) {
				data.itemsLoaded = results.itemsLoaded;
				data.totalCount = results.totalCount;
			});

			$('.events-list-filter-selected').on('click', function () {
				const selected = $(this);
				const filter = selected.closest('.events-list-filter');
				const dropdown = filter.find('.filter-values');
				$('.filter-values').not(dropdown).slideUp();
				dropdown.slideToggle();
			});

			$('.filter-value').on('click', function () {
				const filterValue = $(this);
				const filter = filterValue.closest('.events-list-filter');
				const text = filterValue.text();
				const value = filterValue.data('value');
				const filterName = filter.data('filter');
				const dropdown = filter.find('.filter-values');

				filter.find('.events-list-filter-selected').text(text);
				dropdown.slideUp();
				data[filterName] = value;
				data.offset = 0;
				data.itemsLoaded = 0;
				$.when(submitEventsFilters(data, target, 'replace',  $grid)).done(function (results) {
					data.itemsLoaded = results.itemsLoaded;
					data.totalCount = results.totalCount;
				});

			});

			$('.filter-button-value').on('click', function () {
				const button = $(this);
				const filter = button.closest('.events-list-filter');
				const filterName = filter.data('filter');
				const value = button.data('value');
				button.addClass('active');
				$('.filter-button-value').not(button).removeClass('active');
				data[filterName] = value;
				data.offset = 0;
				data.itemsLoaded = 0;
				$.when(submitEventsFilters(data, target, 'replace',  $grid)).done(function (results) {
					data.itemsLoaded = results.itemsLoaded;
					data.totalCount = results.totalCount;
				});
			});

			$('.events-list__load-more').on('click', function () {
				data.offset = data.offset + data.itemsLoaded;
				$.when(submitEventsFilters(data, target, 'append',  $grid)).done(function (results) {
					data.itemsLoaded = results.itemsLoaded;
					data.totalCount = results.totalCount;
				});
			});
		}

		function submitEventsFilters(data, target, op = 'replace', $grid) {
			console.log(data);
			return $.ajax({
				type: 'POST',
				url: data.endpoint,
				data: data
			}).done(function (results) {

				$('.events-list__count-amount').text(results.totalCount);

				if (op === 'replace') {
          console.log('replace');
          target.html(results.html).ready(function () {
            $grid.imagesLoaded().progress(function () {
              $grid.masonry('reloadItems');
              $grid.masonry('layout');
               AOS.refresh();
            });
          });
				} else if (op === 'append') {
					console.log('append');
          target.append(results.html).ready(function() {
            $grid.masonry('appended', results.html).imagesLoaded().progress(function () {
              $grid.masonry('reloadItems');
              $grid.masonry('layout');
               AOS.refresh();
            });
          });
				}

				if (results.totalCount > results.itemsLoaded && $('.events-list__load-more-wrapper').length) {
					$('.events-list__load-more-wrapper').show();
				} else {
					$('.events-list__load-more-wrapper').hide();
				}
			});
		}

	});
})(jQuery);
